import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  index = 'AntiSpyEmail',
  quiz = 'AntiSpyEmailQuiz',
  help = 'AntiSpyEmailHelp',
  security = 'AntiSpyEmailSecurity',
  leaked = 'AntiSpyEmailLeaked',
  trusted = 'AntiSpyEmailTrusted',
  finish = 'AntiSpyEmailFinish',
  preparing = 'AntiSpyEmailPreparing',
  auth = 'AntiSpyEmailAuth',
  payment = 'AntiSpyEmailPayment',
}

function preloadModule(name: MODULE_ROUTE) {
  const parentRoute = routes.find((layoutRoute) =>
    layoutRoute.children?.find((route) => route.name === name),
  );

  const route = parentRoute?.children?.find((route) => route.name === name);

  if (route && 'component' in route && typeof route.component === 'function') {
    (route.component as unknown as () => void)();
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/safety-check/',
    component: () =>
      import('@/modules/anti-spy-email-after-pay/layout/LayoutPage.vue'),
    meta: {
      i18nAlias: 'pricing',
    },
    children: [
      {
        path: '',
        name: MODULE_ROUTE.index,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/index/PageSafeOnline.vue'),
        meta: {
          abtestGroup: 2,
        },
        beforeEnter() {
          setTimeout(() => {
            Object.values(MODULE_ROUTE)
              .filter((moduleName) => moduleName !== MODULE_ROUTE.index)
              .forEach((moduleName) =>
                preloadModule(moduleName as MODULE_ROUTE),
              );
          }, 1000);
        },
      },
      {
        path: 'help/',
        name: MODULE_ROUTE.help,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/help/PageSafeOnlineHelp.vue'),
      },
      {
        path: 'security/',
        name: MODULE_ROUTE.security,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/security/PageSafeOnlineSecurity.vue'),
      },
      {
        path: 'leaked/',
        name: MODULE_ROUTE.leaked,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/leaked/PageSafeOnlineLeaked.vue'),
      },
      {
        path: 'trusted/',
        name: MODULE_ROUTE.trusted,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/trusted/PageSafeOnlineTrusted.vue'),
      },
      {
        path: 'finish/',
        name: MODULE_ROUTE.finish,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/finish/PageSafeOnlineFinish.vue'),
      },
      {
        path: 'quiz/',
        name: MODULE_ROUTE.quiz,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/quiz/PageQuiz.vue'),
      },
      {
        path: 'preparing/',
        name: MODULE_ROUTE.preparing,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/preparing/PagePreparing.vue'),
      },
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/anti-spy-email-after-pay/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
